import React, { useState, useEffect } from 'react';
import { TextField, IconButton } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { styled } from '@mui/system';
import Autocomplete from '@mui/material/Autocomplete';
import { useNavigate } from 'react-router-dom';

const SearchWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
}));

const StyledAutocomplete = styled(Autocomplete)(({ theme }) => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    transition: 'box-shadow 0.3s ease, transform 0.3s ease',
    '& fieldset': {
      borderColor: theme.palette.primary.main,
    },
  },
}));

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  padding: 8,
  transition: 'transform 0.3s ease, background-color 0.3s ease',
  '&:hover': {
    transform: 'scale(1.1)',
    backgroundColor: theme.palette.action.hover,
  },
  '& .MuiSvgIcon-root': {
    fontSize: 30,
  },
}));

const ErrorMessage = styled('div')(({ theme }) => ({
  color: theme.palette.error.main,
  marginTop: theme.spacing(1),
    alignSelf: 'flex-start',
}));

const SearchBar = ({ products, isRecipes, searchPlaceholder, onSearch, setError }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const navigate = useNavigate();

  const handleSearch = () => {
    if (searchTerm.length < 3) {
      setSuggestions([]);
      onSearch([]);
      setError('');
      return;
    }

    const filteredSuggestions = products.filter((product) =>
      product.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSuggestions(filteredSuggestions);
    onSearch(filteredSuggestions);

    if (filteredSuggestions.length === 0) {
      setError(isRecipes ? 'Nie znaleziono przepisu' : 'Nie znaleziono produktu');
      onSearch([]);
    } else {
      setError('');
    }
  };

  const handleInputChange = (event, newInputValue) => {
    setSearchTerm(newInputValue);
  };

  const handleOptionSelect = (event, value) => {
    const selectedProduct = products.find((product) => product.name === value);
    if (selectedProduct) {
      navigate(isRecipes ? `/przepisy/${selectedProduct.id}` : `/encyklopedia/${selectedProduct.id}`);
    }
  };

  useEffect(() => {
    handleSearch();
  }, [searchTerm]);

  return (
    <SearchWrapper>
      <StyledAutocomplete
        freeSolo
        options={suggestions.map((product) => product.name)}
        onInputChange={handleInputChange}
        onChange={handleOptionSelect}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            placeholder={searchPlaceholder}
            InputProps={{
              ...params.InputProps,
              style: { height: 56 },
              endAdornment: (
                <StyledIconButton onClick={handleSearch}>
                  <SearchIcon />
                </StyledIconButton>
              ),
            }}
          />
        )}
      />
    </SearchWrapper>
  );
};

export default SearchBar;